import Preview from 'components/Preview/Preview';
import { withPreviewSettingsProps } from 'viewModel/previewSettings/withPreviewSettingsProps';

export default withPreviewSettingsProps(Preview);
